/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Searchplaceholder2Inputs */

const zh_organizationsettings_searchplaceholder2 = /** @type {(inputs: Organizationsettings_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索团队成员`)
};

const en_organizationsettings_searchplaceholder2 = /** @type {(inputs: Organizationsettings_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search team members`)
};

const es_organizationsettings_searchplaceholder2 = /** @type {(inputs: Organizationsettings_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar miembros del equipo`)
};

/**
* | output |
* | --- |
* | "Search team members" |
*
* @param {Organizationsettings_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_searchplaceholder2 = /** @type {((inputs?: Organizationsettings_Searchplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Searchplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_searchplaceholder2(inputs)
	if (locale === "en") return en_organizationsettings_searchplaceholder2(inputs)
	return es_organizationsettings_searchplaceholder2(inputs)
});
export { organizationsettings_searchplaceholder2 as "organizationSettings_searchPlaceholder" }